module.exports = __webpack_public_path__ + "assets/119f2ff103e64a0491a531425b9741fd.png";